import {
  Select,
  SelectItem,
  TextArea,
  TextInput,
} from 'carbon-components-react';
import { useReducerSpread } from '../../../../utils/common.util';
import useSWR from 'swr';
import CustomButton from '../../../../components/custom-button/custom-btn.component';

const initialData = {
  programName: '',
  aidType: '',
  amount: '',
  amountType: '',
  academicYearId: '',
  termId: '',
  description: '',
};

export default function CreateProgramForm({
  onSave,
  onCancel,
  initialData: passedInitialData,
  isLoading = false,
  hasError = false,
}) {
  const [formData, setFormData] = useReducerSpread(
    passedInitialData || initialData,
  );

  const { data: academicYears } = useSWR(
    'academic-year/list/?skip=0&take=100&query=',
  );
  const { data: terms } = useSWR(
    formData.academicYearId
      ? `academic-year/terms/?academicYearId=${formData.academicYearId}`
      : null,
  );

  const disabled =
    !formData.programName ||
    !formData.aidType ||
    !formData.amountType ||
    !formData.amount;

  return (
    <div
      className="d-flex-center"
      style={{ maxWidth: '700px', margin: '0 auto', padding: '0 20px' }}
    >
      <form
        className=""
        style={{
          display: 'grid',
          gap: '20px',
          width: '100%',
          marginBottom: '30px',
        }}
      >
        <h2>Program Form</h2>
        <TextInput
          id="programName"
          name="programName"
          type="text"
          labelText="Program Name"
          placeholder="Enter program name"
          value={formData.programName}
          onChange={(e) => setFormData({ programName: e.target.value })}
        />
        <Select
          labelText="Aid Type"
          onChange={(e) => setFormData({ aidType: e.target.value })}
          value={formData.aidType}
        >
          <SelectItem value="" text="" disabled />
          {['Scholarship', 'Discount', 'Waiver']?.map((type) => (
            <SelectItem key={type} value={type} text={type} />
          ))}
        </Select>
        <Select
          labelText="Amount Type"
          onChange={(e) => setFormData({ amountType: e.target.value })}
          value={formData.amountType}
        >
          <SelectItem value="" text="" disabled />
          {['Fixed', 'Percentage']?.map((type) => (
            <SelectItem key={type} value={type} text={type} />
          ))}
        </Select>
        <TextInput
          id="amount"
          name="amount"
          type="number"
          labelText={`Amount (${
            formData.amountType === 'Percentage' ? '%' : 'Currency'
          })`}
          placeholder={
            formData.amountType === 'Percentage'
              ? 'Enter percentage (e.g., 20 for 20%)'
              : 'Enter fixed amount (e.g., 500)'
          }
          value={formData.amount}
          onChange={(e) => {
            const value = e.target.value;
            if (formData.amountType === 'Percentage') {
              // Allow only numbers between 0 and 100 for percentage
              if (
                value === '' ||
                (Number(value) >= 0 && Number(value) <= 100)
              ) {
                setFormData({ amount: value });
              }
            } else {
              // For fixed amount, allow any non-negative number
              if (value === '' || Number(value) >= 0) {
                setFormData({ amount: value });
              }
            }
          }}
        />
        <Select
          labelText="Academic Year"
          onChange={(e) =>
            setFormData({ academicYearId: e.target.value, termId: '' })
          }
          value={formData.academicYearId}
        >
          <SelectItem value="" text="All" />
          {academicYears?.map((year) => (
            <SelectItem key={year.id} value={year.id} text={year.description} />
          ))}
        </Select>
        <Select
          labelText="Term"
          disabled={!formData.academicYearId}
          onChange={(e) => setFormData({ termId: e.target.value })}
          value={formData.termId}
        >
          <SelectItem value="" text="" />
          {terms?.map((term) => (
            <SelectItem key={term.id} value={term.id} text={term.description} />
          ))}
        </Select>
        <TextArea
          id="description"
          name="description"
          className="f-width"
          labelText="Description (Optional)"
          value={formData.description}
          onChange={(e) => setFormData({ description: e.target.value })}
          placeholder="Describe the financial aid program, eligibility criteria, and any other relevant details here."
        />

        <div className="mt-40 d-flex-space-between">
          <CustomButton
            classes={`outline no-hover font-bold secondary`}
            // disabled={isLoading}
            onClick={onCancel}
          >
            Cancel
          </CustomButton>

          <CustomButton
            classes={`font-bold primary`}
            disabled={disabled || isLoading}
            onClick={() => onSave(formData)}
            isLoading={isLoading}
          >
            Save and Continue
          </CustomButton>
        </div>
      </form>
    </div>
  );
}
